import barcodeLocationImageUrl from "@/assets/barcode-location.webp"
import BackButton from "@/components/BackButton"
import { Button } from "@/components/chadcn/Button"
import Page from "@/components/Page"
import { BLOOD_GLUCOSE_DEVICE_NAME } from "@/util/constants"
import ContactSupportLink from "../components/ContactSupportLink"

type FindBarcodeStepProps = {
  onNext: () => void
  onBack: () => void
}

const FindBarcodeStep = ({ onNext, onBack }: FindBarcodeStepProps) => (
  <Page showAppbar={false}>
    <div className="flex min-h-page flex-col gap-6">
      <BackButton customClickHandler={onBack} />
      <div className="flex flex-1 flex-col gap-6">
        <h1 className="text-h1">Find the barcode</h1>
        <p className="text-base text-primary-contrast/70">
          Turn your {BLOOD_GLUCOSE_DEVICE_NAME} over. The barcode is on the white sticker near the
          top, above the IMEI number.
        </p>
        <img
          src={barcodeLocationImageUrl}
          alt={`Back of the ${BLOOD_GLUCOSE_DEVICE_NAME} with the barcode and IMEI number framed in red`}
          className="w-full rounded-lg"
        />
        <ContactSupportLink />
      </div>
      <Button type="button" className="w-full py-2 text-base" onClick={onNext}>
        Scan barcode
      </Button>
    </div>
  </Page>
)

export default FindBarcodeStep
